export const UPDATE_CHANNEL_LIST_LOADING = "UPDATE_CHANNEL_LIST_LOADING"
export const UPDATE_CHANNEL_LIST_PAGINATION = "UPDATE_CHANNEL_LIST_PAGINATION"
export const UPDATE_FETCH_CHANNEL_LIST_DATA = "UPDATE_FETCH_CHANNEL_LIST_DATA"
export const UPDATE_FETCH_CHANNEL_TYPE_LIST = "UPDATE_FETCH_CHANNEL_TYPE_LIST"